@use "ui/styles/colors";
@use "ui/styles/sizes";
@use "ui/styles/fonts";

.trigger {
    display: inline-flex;
}

.triggerButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: sizes.$s8;
    height: sizes.$s8;
    border: none;
    background: transparent;
    border-radius: 50%;
    cursor: pointer;
    color: inherit;
    transition: all 200ms ease-in;

    svg {
        min-width: 1em;
        min-height: 1em;
    }

    &:hover:not(:disabled) {
        background-color: var(--surface-hover);
        color: var(--primary-color, colors.$blue);
    }

    &:focus-visible {
        outline: 2px solid var(--focus-ring);
        outline-offset: 1px;
    }
}

.disabled {
    .triggerButton {
        cursor: not-allowed;
        color: var(--text-disabled, colors.$gray50);
    }
}

.content {
    $gutterLeft: sizes.$s6;
    $gutterRight: sizes.$s5;
    min-width: 160px;
    display: flex;
    flex-direction: column;
    gap: sizes.$s4;
    padding: sizes.$s5 0;

    &.hasHeader {
        padding-top: 0;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: sizes.$s5 $gutterRight sizes.$s5 $gutterLeft;
        gap: sizes.$s4;
        font-size: fonts.$base;
        border-bottom: 1px solid var(--border-color, colors.$gray20);
    }

    .children {
        padding: 0 $gutterRight 0 $gutterLeft;
        display: flex;
        flex-direction: column;
    }

    .menuItems {
        display: flex;
        flex-direction: column;
        list-style: none;
        margin: 0;
        padding: 0;
        font-size: fonts.$mid;

        li {
            list-style: none;
            margin: 0;
            padding: sizes.$s4 $gutterRight sizes.$s4 $gutterLeft;
            cursor: pointer;
            user-select: none;

            &:hover {
                background-color: var(--surface-hover, colors.$gray10);
            }
        }
    }
}